import { render, staticRenderFns } from "./DietSettingsSidebar.vue?vue&type=template&id=668ed9fe&scoped=true&"
import script from "./DietSettingsSidebar.vue?vue&type=script&lang=js&"
export * from "./DietSettingsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DietSettingsSidebar.vue?vue&type=style&index=0&id=668ed9fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ed9fe",
  null
  
)

export default component.exports